import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ManagementService } from '../../services/management.service';
import { ModalLoadingComponent } from '../../../shared/modals/modal-loading/modal-loading.component';
import { ModalSuccessComponent } from '../../../shared/modals/modal-success/modal-success.component';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';

@Component({
  selector: 'app-area-edit-modal',
  templateUrl: './area-edit-modal.component.html',
  styleUrl: './area-edit-modal.component.scss',
  providers: [DialogService],
})
export class AreaEditModalComponent {
  @Input() visible: boolean = false;
  @Input() areaId: number | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() registerComplete = new EventEmitter<void>();

  isDisabled: boolean = true;
  area: string | null = null;
  isLoading: boolean = false;

  hasInteracted: { [key: string]: boolean } = {
    area: false,
  };

  constructor(
    private managementService: ManagementService,
    private dialogService: DialogService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['areaId'] && changes['areaId'].currentValue !== null) {
      this.loadAreaData();
    }
  }

  private loadAreaData(): void {
    this.isLoading = true;
    if (!this.areaId) return;

    this.managementService.getAreaByAreaId(this.areaId).subscribe({
      next: (areaData) => {
        this.area = areaData.areaName;

        this.hasInteracted['area'] = true;
        this.isLoading = false;
        this.validateForm();
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error al obtener el área:', err);
      },
    });
  }

  onChangeInput(event: any, type: string) {
    this.hasInteracted[type] = true;
    switch (type) {
      case 'area':
        this.area = event;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.validateForm();
  }

  validateForm() {
    this.isDisabled = !this.area;
  }

  onEdit() {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    if (this.areaId) {
      const areaId = this.areaId;
      const request = {
        nameArea: this.area,
      };

      const formData = new FormData();

      const appendIfDefined = (key: string, value: any) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      };

      Object.entries(request).forEach(([key, value]) =>
        appendIfDefined(key, value)
      );

      this.managementService.updateArea(formData, areaId).subscribe({
        next: (response) => {
          loadingRef.close();
          const ref = this.dialogService.open(ModalSuccessComponent, {
            header: '',
            data: {
              text: 'El área ha sido actualizada con éxito.',
              title: '¡Éxito!',
              icon: 'pi pi-check-circle',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          this.registerComplete.emit();
          this.closeDialog();
        },

        error: (err) => {
          loadingRef.close();

          const ref = this.dialogService.open(ModalRejectComponent, {
            header: '',
            data: {
              text:
                err.error?.error ||
                'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
              title: '¡Lo sentimos!',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          this.resetForm();
          this.closeDialog();
        },
      });
      // this.closeDialog();
    }
  }

  resetForm() {
    this.area = null;
    this.hasInteracted = {
      area: false,
    };
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.resetForm();
  }
}
